import { Home, Building2, Droplets, Car, TreePine, Fence, Bug, Leaf } from 'lucide-react';

/**
 * Canonical catalog of services the Calculator can render.
 *
 * Keep in sync between:
 *   - ServiceSelector (Calculator service-card grid)
 *   - ServicesOfferedConfig (Settings → App Configuration)
 *
 * Order here is the canonical render order in both surfaces.
 */
export const SERVICE_CATALOG = [
  { id: 'roof',         label: 'Roof Cleaning',         icon: Home      },
  { id: 'siding',       label: 'Siding Cleaning',        icon: Building2 },
  { id: 'gutter',       label: 'Gutter Cleaning',        icon: Droplets  },
  { id: 'driveway',     label: 'Driveways / Walkways',   icon: Car       },
  { id: 'deck',         label: 'Decks / Patios',         icon: TreePine  },
  { id: 'fence',        label: 'Fences',                 icon: Fence     },
  { id: 'pest_control', label: 'Pest Control',           icon: Bug       },
  { id: 'lawn_care',    label: 'Lawn Care',              icon: Leaf      },
];

export const ALL_SERVICE_IDS = SERVICE_CATALOG.map((s) => s.id);
